import { navigateTo } from '@popup/multichain/actions/navigation.actions';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { MenuItemComponent } from 'src/common-ui/menu/menu-item/menu-item.component';
const Menu = ({ title, isBackButtonEnable, isCloseButtonDisabled, menuItems, rightAction, navigateTo, setTitleContainerProperties, showDetachWindowOption, }) => {
    useEffect(() => {
        setTitleContainerProperties({
            title: title,
            isBackButtonEnabled: isBackButtonEnable,
            isCloseButtonDisabled: isCloseButtonDisabled,
            rightAction: rightAction,
            showDetachWindowOption: showDetachWindowOption,
        });
    }, [rightAction]);
    const handleMenuItemClick = (menuItem) => {
        if (menuItem.nextScreen) {
            navigateTo(menuItem.nextScreen);
        }
        else if (menuItem.action) {
            menuItem.action();
        }
    };
    return (React.createElement("div", { className: "menu-page" },
        React.createElement("div", { className: "menu" }, menuItems.map((menuItem, index) => (React.createElement(MenuItemComponent, { menuItem: menuItem, key: index, handleMenuItemClick: handleMenuItemClick, isLast: menuItems.length - 1 === index }))))));
};
const mapStateToProps = (state) => {
    return {};
};
const connector = connect(mapStateToProps, {
    navigateTo,
    setTitleContainerProperties,
});
export const MenuComponent = connector(Menu);
